export default "__VITE_ASSET__bd324743__$_?react__"